import { createFileRoute } from '@tanstack/react-router'
import HolidaySetting from '@/features/holiday-setting'
import { ProtectedRoute } from '@/components/auth/protected-route'
import { Permissions } from '@/constants/roles-permissions'

export const Route = createFileRoute('/_authenticated/holiday-setting')({
  component: HolidaySettingRoute,
})

function HolidaySettingRoute() {
  return (
    <ProtectedRoute requiredPermission={Permissions.HolidayView}>
      <HolidaySetting />
    </ProtectedRoute>
  )
} 